import { BaseHttpService } from '../../../_services/basehttpservice';
import { Injectable } from '@angular/core';
import { WorkTimeModifyBreakDto, WorkTimeModifyAssignmentDto, WorkTimeModifyShiftDto, WorkTimeAssignment, WorkTimeBreak, WorkTimeAddShiftDto, WorkTimeAddBreakDto, WorkTimeRemoveDto, WorkTimeBreakType, WorkTimeHourTypeGroup, WorkTimeModified, WorkTimeVacation, WorkTimeVacationDto, WorkTimeShift, WorkTimeSummaryDto, WorktimeShiftInfo, WorkTimeShiftLocation, WorktimeBreakInfo, WorktimeActionDTO, WorkTimeCostCentre, WorkTimeModifyCostCentreDto, WorkTimeAddAssignmentDto, WorkTimeAddCostCentreDto, WorkTimeStartEndBreakDto } from '../../../_models/work-time/workTime';
import { first } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { Paged } from '../../../_models/paged';
import { Observable } from 'rxjs';
import { ListModel } from '../../../_models/listmodel';
import { HourTypeResponse } from '../interfaces/work-time-hour-type-response';
import { query } from '@angular/animations';
import { AuditLog } from '../../../_models/audit-log/auditLog';

@Injectable({
  providedIn: 'root',
})

/**
 * This service handles operations needed by various components using work time data.
 */
export class WorkTimeService extends BaseHttpService {

  constructor(
  ) {
    super();
  }

  /**
   * Get current worktime status
   */
  getWorktimeStatus(params?: HttpParams): Observable<number> {
    return this.httpClient
      .get<number>(`${this.getUrl()}/WorkTime/mobworktime/shift/checkactive`, {
        params,
      })
      .pipe(first());
  }


  /**
   * Get current shift info
   */
  getWorktimeShiftInfo(params?: HttpParams): Observable<WorktimeShiftInfo> {
    return this.httpClient
      .get<WorktimeShiftInfo>(
        `${this.getUrl()}/worktime/mobworktime/shift/currentshiftinfo`,
        { params }
      )
      .pipe(first());
  }


  /**
   * Get current break info
   */
  getWorktimeBreakInfo(params?: HttpParams): Observable<WorktimeBreakInfo> {
    return this.httpClient
      .get<WorktimeBreakInfo>(
        `${this.getUrl()}/worktime/mobworktime/break/currentbreakinfo`,
        { params }
      )
      .pipe(first());
  }

    /**
   * Stop worktime shift
   */
  finishWorkTimeShift(
    dto: WorktimeActionDTO,
    params?: HttpParams
  ): Observable<string> {
      return this.httpClient
        .put<string>(`${this.getUrl()}/WorkTime/mobworktime/shift/end`, dto, {
          params,
        })
        .pipe(first());
    }

  /**
   * Start worktime shift
   */
  startWorkTimeShift(
    dto: WorktimeActionDTO,
    params?: HttpParams
  ): Observable<string> {
    return this.httpClient
      .put<string | any>(
        `${this.getUrl()}/WorkTime/mobworktime/shift/start`,
        dto,
        { params }
      )
      .pipe(first());
  }
  /**
   * Start worktime Cost Centre
   */
  startWorkTimeCostCentre(costCentreId: number, params?: HttpParams): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.getUrl()}/WorkTime/mobworktime/costcentre/start/${costCentreId}`,
        undefined,
        { params }
      )
      .pipe(first());
  }
  /**
   * Finish worktime Cost Centre
   */
  finishWorkTimeCostCentre(workTimeCostCentreId: number, explanation?: string, params?: HttpParams): Observable<any> {
    let dto = {id: workTimeCostCentreId, explanation: explanation}
    return this.httpClient
      .put<any>(
        `${this.getUrl()}/WorkTime/mobworktime/costcentre/finish`,
        dto,
        { params }
      )
      .pipe(first());
  }
  /**
   * Start worktime break
   */
  startWorkTimeBreak(breakType: number, params?: HttpParams): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.getUrl()}/WorkTime/mobworktime/break/start/${breakType}`,
        undefined,
        { params }
      )
      .pipe(first());
  }

  /**
   * Stop worktime break
   */
  finishWorkTimeBreak(dto?: WorkTimeStartEndBreakDto, params?: HttpParams): Observable<any> {
    return this.httpClient
      .post<any>(`${this.getUrl()}/WorkTime/mobworktime/break/finish`, dto, {
        params,
      })
      .pipe(first());
  }
  /**
   * Add location entry for and worktime shifht
   */
  addLocationToWorkTimeShift(
    location: WorkTimeShiftLocation,
    params?: HttpParams
  ): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.getUrl()}/Positioning/Positioning/worklocation/shift`,
        location,
        { params }
      )
      .pipe(first());
  }

  /**
   * Gets a list of work time shifts using filtering and pagination.
   * @param queryParams Contains pagination and filtering parameters.
   */
  getWorkTimeShiftsPaged(queryParams: HttpParams): Observable<Paged<any>> {
    return this.httpClient.get<Paged<any>>(`${this.getUrl()}/worktime/worktimeshift`, { params: queryParams }).pipe(first());
  }

  /**
   * Gets a list of work time shifts using filtering and pagination.
   * @param queryParams Contains pagination and filtering parameters.
   */
  getWorkTimeShiftsOwnPaged(queryParams: HttpParams): Observable<Paged<any>> {
    return this.httpClient.get<Paged<any>>(`${this.getUrl()}/worktime/worktimeshift/own`, { params: queryParams }).pipe(first());
  }

  /**
   * Gets a list of work time shifts using filtering and pagination.
   * @param queryParams Contains pagination and filtering parameters.
   */
  getOwnNewestWorkTimeShiftId(): Observable<number> {
    return this.httpClient.get<number>(`${this.getUrl()}/worktime/worktimeshift/newestId/own`).pipe(first());
  }

  /**
   * Gets a list of work time shifts using filtering and pagination.
   * @param queryParams Contains pagination and filtering parameters.
   */
  getNewestWorkTimeShiftId(userAccountId: number): Observable<number> {
    return this.httpClient.get<number>(`${this.getUrl()}/worktime/worktimeshift/newestId/${userAccountId}`).pipe(first());
  }

  /**
   * Gets a list of work time durations, break and assignment lengths using filtering.=
   * @param queryParams Contains filtering parameters.
   */
  getWorkTimeBalanceTotal(userAccountId: number): Observable<number> {
    return this.httpClient.get<number>(`${this.getUrl()}/worktime/worktimebalance/total/${userAccountId}`).pipe(first());
  }

  /**
   * Gets a list of work time durations, break and assignment lengths using filtering.=
   * @param queryParams Contains filtering parameters.
   */
  getOwnWorkTimeBalanceTotal(): Observable<number> {
    return this.httpClient.get<number>(`${this.getUrl()}/worktime/worktimebalance/total/own`).pipe(first());
  }



  /**
   * Gets a list of work time durations, break and assignment lengths using filtering.=
   * @param queryParams Contains filtering parameters.
   */
  getWorkTimeSummary(queryParams: HttpParams): Observable<WorkTimeSummaryDto> {
    return this.httpClient.get<WorkTimeSummaryDto>(`${this.getUrl()}/worktime/worktimeshift/summary`, { params: queryParams}).pipe(first());
  }

  /**
   * Gets a list of work time durations, break and assignment lengths using filtering.=
   * @param queryParams Contains filtering parameters.
   */
  getWorkTimeOwnSummary(queryParams: HttpParams): Observable<WorkTimeSummaryDto> {
    return this.httpClient.get<WorkTimeSummaryDto>(`${this.getUrl()}/worktime/worktimeshift/summary/own`, { params: queryParams}).pipe(first());
  }

  /**
   * Gets a worktime assignment by the ID.
   * @param id ID of the worktime assignment.
   */
  getWorkTimeAssignment(id: number): Observable<WorkTimeAssignment> {
    return this.httpClient.get<WorkTimeAssignment>(`${this.getUrl()}/assignment/assignment/worktime/${id}`).pipe(first());
  }

  /**
   * Gets a worktime cost centre by the ID.
   * @param id ID of the worktime cost centre.
   */
  getWorkTimeCostCentre(id: number): Observable<WorkTimeCostCentre> {
    return this.httpClient.get<WorkTimeCostCentre>(`${this.getUrl()}/worktime/worktimecostcentre/${id}`).pipe(first());
  }

  /**
   * Gets a list of work time assignments by the shift ID.
   * @param shiftId ID of the shift.
   */
  getWorkTimeAssignmentsByShift(shiftId: number): Observable<WorkTimeAssignment[]> {
    return this.httpClient.get<WorkTimeAssignment[]>(`${this.getUrl()}/assignment/assignment/worktime/shift/${shiftId}`).pipe(first());
  }

  /**
   * Gets a list of work time breaks by the shift ID.
   * @param shiftId ID of the shift.
   */
  getWorkTimeBreaksByShift(shiftId: number, lang: string): Observable<WorkTimeBreak[]> {
    let queryParams: HttpParams = new HttpParams();
    queryParams = queryParams.append('lang', lang)

    return this.httpClient.get<WorkTimeBreak[]>(`${this.getUrl()}/worktime/worktimebreak/shift/${shiftId}`, { params: queryParams }).pipe(first());
  }

  getCostCentresByShift(shiftId: number): Observable<WorkTimeCostCentre[]> {
    return this.httpClient.get<WorkTimeCostCentre[]>(`${this.getUrl()}/worktime/worktimecostcentre/shift/${shiftId}`).pipe(first());
  }

  /**
   * Gets a list of modified work time assignments by the shift ID.
   * @param shiftId ID of the shift.
   */
  getModifiedAssignmentsByShift(shiftId: number): Observable<WorkTimeModified[]> {
    return this.httpClient.get<WorkTimeModified[]>(`${this.getUrl()}/assignment/assignment/worktime/shift/${shiftId}/getModified`).pipe(first());
  }

  /**
   * Gets a list of modified work time breaks by the shift ID.
   * @param shiftId ID of the shift.
   */
  getModifiedBreaksByShift(shiftId: number, lang: string): Observable<WorkTimeModified[]> {
    let queryParams: HttpParams = new HttpParams();
    queryParams = queryParams.append('lang', lang)

    return this.httpClient.get<WorkTimeModified[]>(`${this.getUrl()}/worktime/worktimebreak/shift/${shiftId}/getModified`, { params: queryParams }).pipe(first());
  }

  /**
   * Gets a list of audit logs for shifts by the shift ID.
   * @param shiftId ID of the shift.
   */
  getShiftAuditLogById(shiftId: number): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeShift/${shiftId}/get/list`).pipe(first());
  }

  /**
   * Gets a list of audit logs for assignments by the shift ID.
   * @param shiftId ID of the shift.
   */
  getAssignmentAuditLogByShift(shiftId: number): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeAssignment/${shiftId}/get/list`).pipe(first());
  }

  /**
   * Gets a list of audit logs for breaks by the shift ID.
   * @param shiftId ID of the shift.
   */
  getBreakAuditLogByShift(shiftId: number): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeBreak/${shiftId}/get/list`).pipe(first());
  }

  /**
   * Gets a list of audit logs for shifts by table name.
   * @param shiftId ID of the shift.
   */
  getAllShiftAuditLogs(): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeShift/-1/get/list`).pipe(first());
  }

  /**
   * Gets a list of audit logs for assignments by table name.
   * @param shiftId ID of the shift.
   */
  getAllAssignmentAuditLogs(): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeAssignment/-1/get/list`).pipe(first());
  }

  /**
   * Gets a list of audit logs for breaks by table name.
   * @param shiftId ID of the shift.
   */
  getAllBreakAuditLogs(): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeBreak/-1/get/list`).pipe(first());
  }

  getShiftAuditLogsByIds(httpParams: HttpParams): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeShift/getbyids`, { params: httpParams }).pipe(first());
  }

  getAssignmentAuditLogsByIds(httpParams: HttpParams): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeAssignment/getbyids`, { params: httpParams }).pipe(first());
  }

  getBreakAuditLogsByIds(httpParams: HttpParams): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeBreak/getbyids`, { params: httpParams }).pipe(first());
  }
  getCostCentreAuditLogsByIds(httpParams: HttpParams): Observable<AuditLog[]> {
    return this.httpClient.get<AuditLog[]>(`${this.getUrl()}/auditlog/auditlog/workTimeCostCentre/getbyids`, { params: httpParams }).pipe(first());
  }


  /**
   * Get work time break types.
   */
  getWorkTimeBreakTypes(lang: string): Observable<WorkTimeBreakType[]> {
    let queryParams: HttpParams = new HttpParams();
    queryParams = queryParams.append('lang', lang)

    return this.httpClient.get<WorkTimeBreakType[]>(`${this.getUrl()}/worktime/worktimebreak/types`, { params: queryParams }).pipe(first());
  }

  /**
   * Get a list of work time break types.
   */
  getWorkTimeBreakTypeList(lang: string): Observable<ListModel[]> {
    let queryParams: HttpParams = new HttpParams();
    queryParams = queryParams.append('lang', lang)

    return this.httpClient.get<ListModel[]>(`${this.getUrl()}/worktime/worktimebreak/types/list`, { params: queryParams }).pipe(first());
  }

  /**
 * Get a list of work time break type name params.
 */
  getWorkTimeBreakTypeNameParams(lang: string): Observable<ListModel[]> {
    let queryParams: HttpParams = new HttpParams();
    queryParams = queryParams.append('lang', lang)

    return this.httpClient.get<ListModel[]>(`${this.getUrl()}/param/param/list/300`, { params: queryParams }).pipe(first());
  }

  /**
   * Get a list of work time hour type group params.
   */
  getWorkTimeHourTypeGroupNameParams(lang: string): Observable<ListModel[]> {
    let queryParams: HttpParams = new HttpParams();
    queryParams = queryParams.append('lang', lang)

    return this.httpClient.get<ListModel[]>(`${this.getUrl()}/param/param/list/320`, { params: queryParams }).pipe(first());
  }

  /**
   * Get a list of work time hour type params.
   */
  getWorkTimeHourTypeNameParams(lang: string): Observable<ListModel[]> {
    let queryParams: HttpParams = new HttpParams();
    queryParams = queryParams.append('lang', lang)

    return this.httpClient.get<ListModel[]>(`${this.getUrl()}/param/param/list/310`, { params: queryParams }).pipe(first());
  }

  /**
   * Get a hour type group including the types and users.
   */
  getWorkTimeHourTypeGroup(nameParamId: number, lang: string): Observable<WorkTimeHourTypeGroup> {
    let queryParams: HttpParams = new HttpParams();
    queryParams = queryParams.append('lang', lang)

    return this.httpClient.get<WorkTimeHourTypeGroup>(`${this.getUrl()}/worktime/worktimehourtypeusergroup/byNameParamId/${nameParamId}`, { params: queryParams }).pipe(first());
  }

  /**
   * Create a new work time break type.
   */
  createWorkTimeBreakType(type: WorkTimeBreakType): Observable<number> {
    return this.httpClient.post<number>(`${this.getUrl()}/worktime/worktimebreak/types`, type).pipe(first());
  }

  /**
   * Create a new work time hour type group.
   */
  createWorkTimeHourTypeGroup(group: WorkTimeHourTypeGroup): Observable<HourTypeResponse> {
    return this.httpClient.post<HourTypeResponse>(`${this.getUrl()}/worktime/worktimehourtypeusergroup`, group).pipe(first());
  }

  /**
   * Creates a new work time shift
   * @param dto Work time shift object to update.
   */
  createWorkTimeShift(dto: WorkTimeAddShiftDto): Observable<number> {
    return this.httpClient.post<number>(`${this.getUrl()}/worktime/worktimeshift/shift`, dto).pipe(first());
  }

  /**
   * Creates a new work time on call duty
   * @param dto Work time shift object to update.
   */
  createWorkTimeOnCallDuty(dto: WorkTimeAddShiftDto): Observable<number> {
    return this.httpClient.post<number>(`${this.getUrl()}/worktime/worktimeshift/oncallduty`, dto).pipe(first());
  }

  /**
   * Modifies a single work time assignment
   * @param dto Work time assignment object to update.
   */
  createWorkTimeAssignment(dto: WorkTimeModifyAssignmentDto): Observable<number> {
    return this.httpClient.post<number>(`${this.getUrl()}/assignment/assignment/worktime/`, dto).pipe(first());
  }

  /**
   * Adds a new work time break
   * @param dto Work time break object to add.
   */
  createWorkTimeBreak(dto: WorkTimeAddBreakDto) {
    return this.httpClient.post(`${this.getUrl()}/worktime/worktimebreak/`, dto).pipe(first());
  }

  /**
   * Modifies a single work time assignment
   * @param dto Work time assignment object to update.
   */
  createWorkTimeCostCentre(dto: WorkTimeAddCostCentreDto): Observable<number> {
    return this.httpClient.post<number>(`${this.getUrl()}/worktime/worktimecostcentre/`, dto).pipe(first());
  }


  /**
   * Update existing work time hour type group.
   */
  updateWorkTimeHourTypeGroup(group: WorkTimeHourTypeGroup): Observable<any> {
    return this.httpClient.put<any>(`${this.getUrl()}/worktime/worktimehourtypeusergroup/${group.id}`, group).pipe(first());
  }

  /**
   * Update the existing work time break type.
   */
  updateWorkTimeBreakType(type: WorkTimeBreakType): Observable<any> {
    return this.httpClient.put<any>(`${this.getUrl()}/worktime/worktimebreak/types/modify/${type.id}`, type).pipe(first());
  }

  /**
   * Modifies a single work time shift
   * @param dto Work time shift object to update.
   */
  updateWorkTimeShift(dto: WorkTimeModifyShiftDto) {
    return this.httpClient.put(`${this.getUrl()}/worktime/worktimeshift/modify`, dto).pipe(first());
  }

  /**
   * Modifies a single work time assignment
   * @param dto Work time assignment object to update.
   */
  updateWorkTimeAssignment(dto: WorkTimeModifyAssignmentDto) {
    return this.httpClient.put(`${this.getUrl()}/assignment/assignment/worktime/modify`, dto).pipe(first());
  }

  /**
   * Modifies a single work time break
   * @param dto Work time break object to update.
   */
  updateWorkTimeBreak(dto: WorkTimeModifyBreakDto) {
    return this.httpClient.put(`${this.getUrl()}/worktime/worktimebreak/modify`, dto).pipe(first());
  }

  /**
   * Modifies a single work time cost centre
   * @param dto Work time cost centre object to update.
   */
  updateWorkTimeCostCentre(dto: WorkTimeModifyCostCentreDto) {
    return this.httpClient.put(`${this.getUrl()}/worktime/worktimecostcentre/modify`, dto).pipe(first());
  }

  /**
   * Remove work time break type.
   */
  deleteWorkTimeBreakType(id: number): Observable<any> {
    return this.httpClient.delete<any>(`${this.getUrl()}/worktime/worktimebreak/types/remove/${id}`).pipe(first());
  }

  /**
   * Remove work time break type.
   */
  deleteHourTypeGroup(id: number): Observable<any> {
    return this.httpClient.delete<any>(`${this.getUrl()}/worktime/worktimehourtypeusergroup/${id}`).pipe(first());
  }

  /**
   * Remove a single work time shift
   * @param id ID of the work time shift to remove.
   */
  deleteWorkTimeShift(dto: WorkTimeRemoveDto) {
    return this.httpClient.put(`${this.getUrl()}/worktime/worktimeshift/remove`, dto).pipe(first());
  }

  /**
   * Remove a single work time assignment
   * @param id ID of the work time assignment to remove.
   */
  deleteWorkTimeAssignment(dto: WorkTimeRemoveDto) {
    return this.httpClient.put(`${this.getUrl()}/assignment/assignment/worktime/remove`, dto).pipe(first());
  }

  /**
   * Remove a single work time break
   * @param dto Work time remove dto object.
   */
  deleteWorkTimeBreak(dto: WorkTimeRemoveDto) {
    return this.httpClient.put(`${this.getUrl()}/worktime/worktimebreak/remove`, dto).pipe(first());
  }

  /**
   * Remove a single work time cost centre
   * @param dto Work time remove dto object.
   */
  deleteWorkTimeCostCentre(dto: WorkTimeRemoveDto) {
    return this.httpClient.put(`${this.getUrl()}/worktime/worktimecostcentre/remove`, dto).pipe(first());
  }

  /**
   * Convert the date object to suitable work time date string. UTC time with seconds and milliseconds set to zero.
   * @param date Date object to convert
   */
  toWorkTimeDateString(date: Date): string {
    date.setUTCSeconds(0, 0);
    return date.toUTCString();
  }

  getShiftInformation(id: number) {
    return this.httpClient.get<WorkTimeShift>(`${this.getUrl()}/WorkTime/WorkTimeShift/${id}`).pipe(first());
  }

  getShiftDurations(id: number, assignments:boolean = false, breaks:boolean = false, balances:boolean = false) {
    let queryParams: HttpParams = new HttpParams();
    queryParams = queryParams.append('assignments', assignments);
    queryParams = queryParams.append('breaks', breaks);
    queryParams = queryParams.append('balances', balances);
    return this.httpClient.get<any>(`${this.getUrl()}/WorkTime/WorkTimeShift/${id}/durations`, {params: queryParams}).pipe(first());
  }

  getShiftBreakDurations(id: number) {
    return this.httpClient.get<number>(`${this.getUrl()}/WorkTime/WorkTimeBreak/shift/${id}/breaksdurations`).pipe(first());
  }

  getShiftAssignmentDurations(id: number) {
    return this.httpClient.get<number>(`${this.getUrl()}/assignment/Assignment/worktime/shift/${id}/assignmentsdurations`).pipe(first());
  }

  getVacations(httpParams: HttpParams): Observable<Paged<WorkTimeVacation>> {
    return this.httpClient.get<Paged<WorkTimeVacation>>(`${this.getUrl()}/WorkTime/WorktimeVacation`, { params: httpParams }).pipe(first());
  }
  getVacation(id: number): Observable<WorkTimeVacation> {
    return this.httpClient.get<WorkTimeVacation>(`${this.getUrl()}/WorkTime/WorktimeVacation/${id}`,).pipe(first());
  }
  deleteVacation(id: number): Observable<any> {
    return this.httpClient.delete<any>(`${this.getUrl()}/WorkTime/WorktimeVacation/${id}`,).pipe(first());
  }
  startVacation(id: number): Observable<any> {
    return this.httpClient.get<any>(`${this.getUrl()}/WorkTime/WorktimeVacation/startVacation/${id}`,).pipe(first());
  }
  endVacation(id: number): Observable<any> {
    return this.httpClient.get<any>(`${this.getUrl()}/WorkTime/WorktimeVacation/endVacation/${id}`,).pipe(first());
  }
  modifyVacation(id: number, dto: WorkTimeVacation): Observable<WorkTimeVacation> {
    return this.httpClient.put<WorkTimeVacation>(`${this.getUrl()}/WorkTime/WorktimeVacation/${id}`,dto).pipe(first());
  }
  createVacation(dto: WorkTimeVacationDto): Observable<WorkTimeVacation> {
    return this.httpClient.post<WorkTimeVacation>(`${this.getUrl()}/WorkTime/WorktimeVacation`,dto).pipe(first());
  }
}
